import { useDispatch, useSelector } from 'react-redux'

import { getGame } from 'selectors'
import { updateGame } from '@fedsim/actions'
import getDayOfYear from 'date-fns/getDayOfYear'
import getMonth from 'date-fns/getMonth'
import getWeek from 'date-fns/getWeek'
import getYear from 'date-fns/getYear'

export function useGame () {
  const dispatch = useDispatch()
  const rawGame = useSelector(getGame)

  let game = rawGame ? rawGame[0] : false
  const newDate = game?.date ? new Date(game?.date) : new Date()
  const calculated = {
    date: newDate,
    dayOfYear: getDayOfYear(newDate),
    month: getMonth(newDate),
    week: getWeek(newDate),
    year: getYear(newDate)
  }

  if (!game) {
    dispatch({
      type: 'ADD_GAME',
      payload: {
        pageId: 1
      }
    })
  }

  const actions = {
    onUpdate: props =>
      dispatch(
        updateGame({
          ...game,
          ...props
        })
      )
  }

  return {
    ...actions,
    model: game,
    calculated
  }
}

export function useGameBrandIds() {
  const { onUpdate, model: { brandIds = [] } } = useGame()

  const onChangeBrandIds = brandId => {
    const ids = brandIds.indexOf(brandId) > -1
      ? brandIds.filter(item => item !== brandId)
      : [...brandIds, brandId]

    onUpdate({ brandIds: ids })
  }

  return {
    onChangeBrandIds,
    brandIds
  }
}

export default useGame
